import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { payrollRoleOptions } from "components/EmployeeProfile";
import { HoverEmployeeNotesButton } from "components/HoverEmployeeNotesButton";
import { format } from "date-fns";
import { useEmployeeNotesModal } from "helpers/employeeNotes";
import React from "react";
import { useAppSelector } from "store/hooks";
import { selectAllRrUsers } from "store/reducers";

import { EmployeeLink } from "./EmployeeLink";
import { Badge } from "../components/Badge";
import { Button } from "../components/button";

type Props = {
  employee: Employee;
  onEdit: (employeeId: number) => void;
};

export function EmployeeEdit({ employee, onEdit }: Props) {
  const rrUsers = useAppSelector(selectAllRrUsers);
  const rrUsersStatus = useAppSelector((state) => state.rrUser.status);
  const { openEmployeeNotesModal } = useEmployeeNotesModal();

  const rrUser = rrUsers.find((user) => user.id === employee.radreport_user_id);
  const startDate = employee.xero_StartDate && new Date(employee.xero_StartDate);
  const terminationDate = employee.xero_TerminationDate && new Date(employee.xero_TerminationDate);
  const linkWarningColour = terminationDate ? "none" : "warning";
  const payrollRole = payrollRoleOptions.find(
    (role) => role.value === (employee.payroll_role === "dev" ? "employee" : employee.payroll_role),
  );

  return (
    <tr>
      <td
        title={`${employee.name} [${employee.id}] ${employee.xero_Email}`}
        className="table-body-cell text-left font-semibold"
      >
        <span className="flex items-center">
          {employee.name}
          <span className="ml-1">
            <EmployeeLink employee={employee} />
          </span>
          <HoverEmployeeNotesButton employeeId={employee.id} onClick={() => openEmployeeNotesModal(employee.id)} />
        </span>
      </td>
      <td className="table-body-cell">
        {rrUsersStatus === "succeeded" && rrUser?.active && (
          <span title={`${rrUser.name}. ${rrUser.username}. [${rrUser.id}]`}>
            <FontAwesomeIcon icon="check" className="text-success" /> RadReport linked
          </span>
        )}
        {rrUsersStatus === "succeeded" && rrUser && !rrUser.active && (
          <span title={`${rrUser.name}. ${rrUser.username}. [${rrUser.id}]`}>
            <Badge size="sm" colour={linkWarningColour}>
              RadReport inactive
            </Badge>
          </span>
        )}
        {rrUsersStatus === "succeeded" && employee.radreport_user_id != null && !rrUser && (
          <Badge size="sm" colour={linkWarningColour}>
            Linked RadReport account unavailable
          </Badge>
        )}
        {employee.radreport_user_id == null && (
          <Badge size="sm" colour={linkWarningColour}>
            Not linked to RadReport
          </Badge>
        )}
      </td>
      <td className="table-body-cell">
        {startDate && <div>Started {format(startDate, "dd/MM/yyyy")}</div>}
        {terminationDate && <div>Ended {format(terminationDate, "dd/MM/yyyy")}</div>}
      </td>
      <td className="table-body-cell">{payrollRole?.label}</td>
      <td className="table-body-cell">
        <Button onClick={() => onEdit(employee.id)}>Edit</Button>
      </td>
    </tr>
  );
}
